"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoModal = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _Controls = require("./parts/Controls");
var _FullscreenModalLayout = require("./parts/FullscreenModalLayout");
var _Content = require("./Content");
var _prepareListingUrl = require("./utils/prepareListingUrl");
var _ModalCustomOverlay = require("../../common/ModalCustomOverlay");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PromoModal = props => {
  const {
    promo,
    controls,
    onOpenChange,
    open,
    onCianMortgageClick,
    onCreditFullPriceClick,
    onNewbuildingListingLinkClick,
    onNewbuildingLinkClick,
    newbuildingCountText,
    config,
    stickyControls = true,
    size = 'S'
  } = props;
  const deviceType = (0, _uiKit.useDeviceType)();

  /**
   * При возможности открытия модалки над модалкой в мобильной версии,
   * сделать корневую полноэкранной
   */
  const isModalFullscreen = React.useMemo(() => {
    if (deviceType !== 'phone') {
      return false;
    }

    // Наличие модалки переменной ставки
    const hasVariableMortageRate = promo.features && promo.features.some(feature => feature.valueChange?.dialog);
    // Наличие новой модалки переменной ставки
    const hasNewFullCreditPrice = promo.features && promo.features.some(feature => feature.type === 'fullCreditPrice');
    return hasVariableMortageRate || hasNewFullCreditPrice;
  }, [deviceType, promo]);
  const listingUrl = React.useMemo(() => {
    const {
      listingBaseUrlDesktop,
      listingBaseUrlMobile
    } = config;
    if (!listingBaseUrlDesktop || !listingBaseUrlMobile) {
      return undefined;
    }
    return (0, _prepareListingUrl.prepareListingUrl)({
      deviceType,
      newbuildings: promo.availableJks,
      baseUrlDesktop: listingBaseUrlDesktop,
      baseUrlMobile: listingBaseUrlMobile
    });
  }, [promo, deviceType, config]);
  const handleClose = React.useCallback(() => onOpenChange(false), [onOpenChange]);
  if (isModalFullscreen) {
    return /*#__PURE__*/React.createElement(_uiKit.ModalFullscreen, {
      open: open,
      onClose: handleClose,
      theme: "white"
    }, /*#__PURE__*/React.createElement(_FullscreenModalLayout.FullscreenModalLayout, {
      onClose: handleClose
    }, /*#__PURE__*/React.createElement(_Content.Content, {
      promo: promo,
      mortgageLegalInfo: promo.mortgageLegalInfo,
      mortgagePartnerLink: config.mortgagePartnerLink,
      onCianMortgageClick: onCianMortgageClick,
      onCreditFullPriceClick: onCreditFullPriceClick,
      onNewbuildingListingLinkClick: onNewbuildingListingLinkClick,
      onNewbuildingLinkClick: onNewbuildingLinkClick,
      fullCreditPriceModalText: config.fullCreditPriceModalText,
      listingUrl: listingUrl,
      newbuildingCountText: newbuildingCountText,
      size: size
    }), /*#__PURE__*/React.createElement(_Controls.Controls, {
      fixed: true
    }, controls)));
  }
  return /*#__PURE__*/React.createElement(_uiKit.ModalRoot, {
    open: open,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(_uiKit.ModalContent, {
    size: size,
    overlay: deviceType === 'phone' ? 'blured' : 'transparent'
  }, deviceType !== 'phone' && /*#__PURE__*/React.createElement(_ModalCustomOverlay.ModalCustomOverlay, null), /*#__PURE__*/React.createElement(_uiKit.ModalCloseButton, {
    title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    size: "XS",
    theme: "fill_light",
    icon: /*#__PURE__*/React.createElement(_icons.IconActionClose16, null),
    tabIndex: -1
  }), /*#__PURE__*/React.createElement(_uiKit.ModalBody, null, /*#__PURE__*/React.createElement(_Content.Content, {
    promo: promo,
    mortgageLegalInfo: promo.mortgageLegalInfo,
    mortgagePartnerLink: config.mortgagePartnerLink,
    onCianMortgageClick: onCianMortgageClick,
    onCreditFullPriceClick: onCreditFullPriceClick,
    onNewbuildingListingLinkClick: onNewbuildingListingLinkClick,
    onNewbuildingLinkClick: onNewbuildingLinkClick,
    fullCreditPriceModalText: config.fullCreditPriceModalText,
    listingUrl: listingUrl,
    newbuildingCountText: newbuildingCountText,
    size: size
  })), /*#__PURE__*/React.createElement(_uiKit.ModalFooter, {
    sticky: stickyControls
  }, /*#__PURE__*/React.createElement(_Controls.Controls, null, controls))));
};
exports.PromoModal = PromoModal;